


































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { CartGetters, UserGetters } from '@/Getters';
import { ICartCourse, IUserSession } from '@/interfaces';
import { AjaxHelper } from '@/AjaxHelper';
import { copyToClipboard, showAxiosErrorMessage } from '@/utils';

import DngMenu from '@/components/Menu.vue';
import Splitter from '@/components/Splitter.vue';

interface Crumb {
  href?: string;
  title: string;
}

@Component({
  name: 'app-layout',
  components: { DngMenu, Splitter }
})
export default class LayoutComponent extends Vue {
  public showMenu = false;
  public showSideMenu = false;
  public moodleUrl = '/learn';

  public get crumbs(): Crumb[] {
    const result: Crumb[] = [];

    const crumbs = this.$route.meta.breadcrumbs as string[];
    for (let i = 0; i < crumbs.length; ++i) {
      const route = this.$router.resolve({ name: crumbs[i] });
      result.push({ href: route.href, title: route.route.meta.title });
    }
    return result;
  }

  public get user(): IUserSession | null { return this.$store.getters[UserGetters.getUser]; }
  public get cartItems(): ICartCourse[] { return this.$store.getters[CartGetters.getCourses]; }
  public get isAuthenticated(): boolean { return this.$store.getters[UserGetters.isAuthenticated]; }
  public get isAdmin(): boolean { return this.$store.getters[UserGetters.isAdmin]; }

  public async mounted() {
    this.moodleUrl = await AjaxHelper.get<string>('/moodleurl');
  }

  public async logout() {
    if (await this.$store.dispatch('logout')) {
      this.$alert.success('Successfully Logged Out');
      this.$router.push('/');
    }
  }

  public isActive(url: string) {
    return this.$route.path.indexOf(url) !== -1;
  }

  public async copyApiTokenToClipboard() {
    try {
      const token = await AjaxHelper.get<string>('/apitokengenerator');
      copyToClipboard(token);
      this.$alert.success('Copied API Token to Clipboard');
    } catch (ex) {
      console.log(ex);
      showAxiosErrorMessage(ex);
    }
  }

  @Watch('$route')
  public onRouteChange() {
    this.showMenu = false;
    this.showSideMenu = false;
  }
}
